// Build-time configuration (see .env.example). No App Check keys: the platform ships no App Check
// anywhere, so there is no reCAPTCHA site key and no debug token to read here (DECISIONS D39).
import { DEFAULT_EVENT_ID } from '@spark/shared'

const env = import.meta.env

export const USE_EMULATORS = env.VITE_USE_EMULATORS === '1' || env.VITE_USE_EMULATORS === 'true'
export const EVENT_ID: string = env.VITE_EVENT_ID || DEFAULT_EVENT_ID
export const FUNCTIONS_REGION: string = env.VITE_FUNCTIONS_REGION || 'us-central1'

export const firebaseConfig = {
  apiKey: env.VITE_FIREBASE_API_KEY || 'demo-api-key',
  authDomain: env.VITE_FIREBASE_AUTH_DOMAIN || 'demo-spark-midwest.firebaseapp.com',
  projectId: env.VITE_FIREBASE_PROJECT_ID || 'demo-spark-midwest',
  storageBucket: env.VITE_FIREBASE_STORAGE_BUCKET || 'demo-spark-midwest.appspot.com',
  appId: env.VITE_FIREBASE_APP_ID || undefined,
  messagingSenderId: env.VITE_FIREBASE_MESSAGING_SENDER_ID || undefined,
}

/** Emulator ports (defaults match firebase.json; the QA runner overrides them per slot). */
export const EMULATOR_PORTS = {
  auth: Number(env.VITE_EMU_AUTH_PORT || 9099),
  firestore: Number(env.VITE_EMU_FIRESTORE_PORT || 8181),
  functions: Number(env.VITE_EMU_FUNCTIONS_PORT || 5051),
  storage: Number(env.VITE_EMU_STORAGE_PORT || 9199),
}
